import React from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { a11yProps, TabPanel } from '../../../components/TabsHelper'
import MainRegularKeksList from './MainRegularKeksList'
import BackButton from '../../../components/BackButton'
import LanguageStrings from '../../../i18n/locales'
import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '../../../components/Button'
import MainKeyMappings from './MainKeyMappings'
import MainHybridKeksList from './hybrid/MainHybridKeksList'
const HSMConfigurationStrings = LanguageStrings().HSMConfiguration.MainComponent

const HSMConfigurationMainComponent = (): JSX.Element => {
  const navigate = useNavigate()
  const location = useLocation()
  const sharedFontStack = 'inherit'
  const tabFontSize = '14px'
  const activeStyle = { fontSize: tabFontSize, color: '#F0F0F0', fontWeight: 500, fontFamily: sharedFontStack, textTransform: 'none' }
  const inActiveStyle = { fontSize: tabFontSize, color: '#A0A0A0', fontWeight: 500, fontFamily: sharedFontStack, textTransform: 'none' }

  const getTabFromUrl = (): number => {
    switch (location.pathname) {
      case '/hsm-hybrid-kek-configuration':
        return 1
      case '/device-key-mappings':
        return 2
      default:
        return 0
    }
  }

  const [currTab, setCurrTab] = React.useState(getTabFromUrl())

  React.useEffect(() => {
    setCurrTab(getTabFromUrl())
  }, [location.pathname])

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setCurrTab(newValue)
    if (newValue === 0) navigate('/hsm-regular-kek-configuration')
    else if (newValue === 1) navigate('/hsm-hybrid-kek-configuration')
    else if (newValue === 2) navigate('/device-key-mappings')
  }

  const getStyle = (index: number): any => {
    if (index === currTab) return activeStyle
    return inActiveStyle
  }

  const getTopUtilityButtons = (): JSX.Element => {
    if (currTab === 0) {
      return (
        <span id="top-right-ami-utilities">
          <Button
            sx={{ marginRight: '1em' }}
            width="fit-content"
            onClick={() => {
              navigate('/add-regular-kek')
            }}
            dataTestId="create-report-template-btn"
          >
            {HSMConfigurationStrings.AddRegularKEK}
          </Button>
        </span>
      )
    } else if (currTab === 1) {
      return (
        <span id="top-right-ami-utilities">
          <Button
            sx={{ marginRight: '1em' }}
            width="fit-content"
            onClick={() => {
              navigate('/add-hybrid-kek')
            }}
            dataTestId='import-asset-list-btn'
          >
            {HSMConfigurationStrings.AddHybridKEK}
          </Button>
        </span>
      )
    } else if (currTab === 2) {
      return (
        <span id="top-right-ami-utilities">
          <Button
            sx={{ marginRight: '1em' }}
            width="fit-content"
            onClick={() => {
              navigate('/add-key-type-mapping')
            }}
            dataTestId='import-asset-list-btn'
          >
            {HSMConfigurationStrings.AddKeyTypeMapping}
          </Button>
        </span>
      )
    } else {
      return <></>
    }
  }

  return (
    <div style={{ width: 'calc(100vw - 3.5rem)', paddingRight: '1rem' }}>
      <div className="topUtilityBar">
        <BackButton onclick={() => { navigate('/card') }} />
        <span id="componentTitle">{HSMConfigurationStrings.HSMKeyManagement}</span>
        {getTopUtilityButtons()}
      </div>
      <div className="reports-template">
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: '3px solid #404040', paddingLeft: 0 }}>
            <Tabs
              value={currTab}
              onChange={handleChange}
              aria-label="basic tabs example"
              TabIndicatorProps={{ style: { height: '2px', borderRadius: '1px' } }}
            >
              <Tab style={getStyle(0)} label={HSMConfigurationStrings.HSMKeys} {...a11yProps(0)} />
              <Tab style={getStyle(1)} label={HSMConfigurationStrings.HybridKeks} {...a11yProps(1)} />
              <Tab style={getStyle(2)} label={HSMConfigurationStrings.KeyTypeMappings} {...a11yProps(2)} />
            </Tabs>
          </Box>
          <TabPanel value={currTab} index={0}>
            <MainRegularKeksList />
          </TabPanel>
          <TabPanel value={currTab} index={1}>
            <MainHybridKeksList />
          </TabPanel>
          <TabPanel value={currTab} index={2}>
            <MainKeyMappings />
          </TabPanel>
        </Box>
      </div>
    </div>
  )
}

export default HSMConfigurationMainComponent
